var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBonlivaLogo = function SvgBonlivaLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 39.33",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff867b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bonliva-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lager_1",
    "data-name": "Lager 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.62.72C21,.72,25.16,5,25.16,10.92A8.41,8.41,0,0,1,19.66,19a9,9,0,0,1,6.68,9c0,6.14-4.59,10.58-11.7,10.58H0V.72ZM12.5,16.37c3.37,0,5.39-1.87,5.39-4.75S16,6.91,12.45,6.91H7.26v9.45Zm.75,16.08c3.58,0,5.72-1.87,5.72-4.91S17,22.46,13.35,22.46H7.26v10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.84,16.8a16.72,16.72,0,0,1,2.4-8.66A16.8,16.8,0,1,0,63.3,31.19,16.8,16.8,0,0,1,37.84,16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.43,16.8A16.8,16.8,0,0,0,40.24,8.14,16.8,16.8,0,0,1,63.3,31.19,16.79,16.79,0,0,0,71.43,16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.94,38.59V.72h7.79V38.59Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "129.83 31.42 129.83 0.72 122.43 0.72 122.43 38.59 143.99 38.59 146.99 31.42 129.83 31.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "103.32 0.72 103.32 25.53 86.25 0.72 86.25 0.72 77.64 0.72 79.25 3.06 79.25 38.59 86.62 38.59 86.62 13.78 103.7 38.59 110.69 38.59 110.69 0.72 103.32 0.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "197.56 0.72 187.42 28.56 177.28 0.72 169.17 0.72 183.79 38.59 191.05 38.59 205.67 0.72 197.56 0.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.15,3.08l1-2.36H219L203.12,38.59h7.73l3.14-7.8h15.14l3.14,7.8H240Zm-8.45,21L221.56,12l4.86,12.06Z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBonlivaLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bonliva-logo.8ecc72d1f59a1b3179406a0c4331fc77.svg";